<style lang="less" scoped>
.ol-popup {position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;left: -50px;}
.ol-popup:after,.ol-popup:before {top: 100%;border: solid transparent;content: " ";height: 0;width: 0;position: absolute; pointer-events: none;}
.ol-popup:after {border-top-color: white;border-width: 10px;left: 48px;margin-left: -10px;}
.ol-popup:before {border-top-color: #cccccc;border-width: 11px;left: 48px;margin-left: -11px;}
.popup-content {width: 400px;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 0 20px;height: 200px;overflow: auto;}
.ol-popup-closer:after {content: "✖";}
.title{width: 410px; height: 30px;background: rgba(33, 185, 191, 0.6);margin: 0;display: flex;justify-content: space-between;line-height: 30px;padding: 0 15px;color: #fff;}
</style>

<template>
  <div>
     <div id="popup" class="ol-popup" v-show="flag">
       <p class="title">
         <span>查看属性</span>
         <a href="#" id="popup-closer" class="ol-popup-closer"></a>
       </p>
      <div id="popup-content" class="popup-content"></div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css'
import Overlay from 'ol/Overlay'
export default {
  data()
  {
    return {
      map: null,
      overlay: null,
      flag: false
    }
  },
  methods:
  {
    /**
     * @method
     * @params  map {} 地图信息
     * @params  params {Object} 属性信息
     * @param是  evt 点击事件参数
     */
    propertiesview(map, params, evt)
    {
      this.flag = true
      // 使用变量存储弹窗所需的 DOM 对象
      var container = document.getElementById('popup')
      var closer = document.getElementById('popup-closer')
      var content = document.getElementById('popup-content')
      // 创建一个弹窗 Overlay 对象
      this.overlay = new Overlay({
        element: container, //绑定 Overlay 对象和 DOM 对象的
        autoPan: true, // 定义弹出窗口在边缘点击时候可能不完整 设置自动平移效果
        autoPanAnimation: {
          duration: 250 //自动平移效果的动画时间 9毫秒
        }
      })
      // 将弹窗添加到 map 地图中
      map.addOverlay(this.overlay)
      let _that = this
      /**
      * 添加单击响应函数来处理弹窗动作
      */
      //获取弹框信息
      let innehtml = ''
      for (let i in params)
        innehtml += `<p>${i}: &nbsp&nbsp${params[i]}</p>`
      content.innerHTML = innehtml
      _that.overlay.setPosition(evt.coordinate) //把 overlay 显示到指定的 x,y坐标
      /**
      * 为弹窗添加一个响应关闭的函数
      */
      closer.onclick = function()
      {
        _that.overlay.setPosition(undefined)
        closer.blur()
        return false
      }
    },
    closerFrame()
    {
      var closer = document.getElementById('popup-closer')
      if (this.overlay)
        this.overlay.setPosition(undefined)
      closer.blur()
      return false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/PropertiesView.vue